import script from "./D2Pi2.vue?vue&type=script&setup=true&lang=js"
export * from "./D2Pi2.vue?vue&type=script&setup=true&lang=js"

import "./D2Pi2.vue?vue&type=style&index=0&id=abc10ef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abc10ef8"]])

export default __exports__